module.exports = __webpack_public_path__ + "img/slider-12.0af10d38.jpg";